import { useState } from "react";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const AdminReactivateUserModal = ({
    show,
    close,
    email,
    reactivateUser,
    businessId,
    user,
    triggerActiveUserStatus,
    isLoading,
}) => {
    const [localLoading, setLocalLoading] = useState(false);

    const handleConfirm = async () => {
        setLocalLoading(true);
        await reactivateUser({
            updated_by: "arbiter",
            users: [
                {
                    email: user?.email,
                    business_id: businessId,
                },
            ],
        }).unwrap();
        triggerActiveUserStatus({ email: user?.email });
        setLocalLoading(false);
        close();
    };

    return (
        <Dialog open={show} onClose={close}>
            <DialogTitle sx={{ background: "white" }}>
                CONFIRM REACTIVATION
            </DialogTitle>
            <DialogContent
                sx={{
                    maxWidth: "600px",
                    minWidth: "320px",
                    color: "black",
                    letterSpacing: "0.00938em",
                    padding: "0px 24px",
                }}
            >
                <div style={{ marginBottom: "18px", wordBreak: "break-word" }}>
                    <p style={{ marginBottom: "0px" }}>
                        Are you sure you want to reactivate the account of&nbsp;
                        <b>{email}</b>?
                    </p>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <div
                        style={{
                            listStyle: "none",
                            marginTop: "5px",
                            border: "1px solid lightgray",
                            borderRadius: "3px",
                            padding: "5px",
                            paddingLeft: "10px",
                            marginBottom: "5px",
                            backgroundColor: "whitesmoke",
                        }}
                    >
                        <strong>Note:&nbsp;</strong> This process may take a few minutes to complete. The user will be able to access their account once reactivated.
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "flex-end" }}>
                <Stack
                    direction="row"
                    spacing={5}
                    sx={{
                        padding: "0.2rem 0rem",
                        margin: "0 auto",
                        alignContent: "center",
                        justifyContent: "center",
                    }}
                >
                    <Button
                        title="Cancel"
                        sx={{
                            backgroundColor: "white",
                            letterSpacing: "0.5px",
                            border: "1px solid gray",
                            padding: "4px 16px",
                            borderRadius: "3px",
                            fontSize: "14px",
                            color: "black",
                            cursor: `${localLoading ? "not-allowed" : "pointer"}`,
                        }}
                        onClick={close}
                        disabled={localLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        title="Confirm Reactivation"
                        sx={{
                            backgroundColor: "green",
                            letterSpacing: "0.5px",
                            padding: "4px 16px",
                            borderRadius: "3px",
                            fontSize: "14px",
                            color: "white",
                            cursor: `${localLoading ? "not-allowed" : "pointer"}`,
                            "&:hover": {
                                backgroundColor: "#015e01",
                                color: "white",
                            },
                        }}
                        onClick={handleConfirm}
                        disabled={localLoading || isLoading}
                    >
                        {localLoading || isLoading ? (
                            <>
                                <CircularProgress size={14} sx={{ color: "white" }} />
                                <span style={{ marginLeft: "5px" }}>Reactivating...</span>
                            </>
                        ) : (
                            "Confirm"
                        )}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default AdminReactivateUserModal;